import React, { Component } from 'react'
import request from "../../../lib/requester";
import _, { toNumber } from "lodash";
import { Link } from "react-router-dom";
import moment from "moment";
import DatePicker from "react-datepicker";
import { Loader } from "react-overlay-loader";

class ClaimDetailCHD extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      General_SkpNumber: '',
      General_ProgramNumber: '',
      General_Principal: '',
      General_ReffNumber: '',
      General_ProgramType: '',
      General_ProgramDescription: '',
      General_BudgetType: '',
      General_AssignmentType: '',
      General_ProgramSubmittedDate: '',
      General_StartDate: '',
      General_EndDate: '',
      General_ClaimExpDate: '',
      General_Budget: '',
      General_BudgetRemaining: '',
      General_SalesTarget: '',
      General_CustomerPPHType: '',
      General_PPhRate: '',
      General_PrincipalCode: '',
      Customer_Id: '',
      Customer_Name: '',
      Customer_NPWP: '',
      Customer_NPWPName: '',
      Customer_NPWPAddress: '',
      Customer_BankName: '',
      Customer_BankAccountNo: '',
      Customer_BankAccountOwner: '',
      Customer_PKP_Badan: '',
      Customer_Potong_Pajak: '',
      Customer_Is_Hold: null,
      Customer_Package: '',
      Claim_PaymentMethod: 'TRF',
      Claim_Activity: '',
      Claim_CostCenter: '',
      Claim_DPP: '',
      Claim_PPh: '',
      Claim_PPhRate: '',
      Claim_PPn: '',
      Claim_TaxNo: '',
      Claim_TotalAmount: '',
      Claim_SKB: '',
      Claim_CustomerReceipt: '',
      Claim_TotalSales: '',
      Claim_TaxDate: '',
      Claim_SKBNumber: '',
      Claim_Reject_Reason: '',
      Claim_SKB_Start_Date: '',
      Claim_SKB_End_Date: '',
      Claim_Bukpot: 0,
      Claim_Nett: 0,
      Program_Customer_ID: '',
      Attachment_Display: 'N',
      Attachment_Data: 'N',
      Attachment_Jml_Display: '',
      Attachment_Jml_Data: '',
      Show_Display_Upload: false,
      Attachment: [],
      Product_List: [],
      lovActivity: [],
      lovCostCenter: [],
      Document_List: [],
      Document_Selected: [],
      fileRequired: { filename: '', path: '' },
      fileSKB: { filename: '', path: '' },
      error: [],
      success: '',
      user: JSON.parse(window.localStorage.getItem('is_user')),
      ppnrate: 10,
    }
  }

  componentDidMount = () => {
    this.getClaimData()
  }

  showNotification = () => {
    if (this.state.success.length > 0) {
      return (
        <div className="alert alert-success" role="alert">
          <i className="fa fa-check" /> {this.state.success}
        </div>
      );
    } else if (this.state.error.length > 0) {
      return (
        <div className="alert alert-danger" role="alert">
          <ul>
            {this.state.error.map((item, index) => {
              return <li key={index}><i class="fas fa-exclamation-triangle" /> {item}</li>;
            })}
          </ul>
        </div>
      );
    }
  }

  getClaimData = () => {
    let url = '/api/traces_chd/v1/claim/data-claim-by-id'
    let { id } = this.props.match.params;
    let param = {
      claim_id: id
    }

    this.setState({ loading: true })
    request.postCHD(url, param, {
      success: function (response) {
        let { Program, Document, Claim, Product, Activity, CostCenter } = response.data.data

        // Rebuild Product
        let NewProduct = Product.map((item, index) => {
          item.item_actual = '0'
          return item
        })

        this.setDefaultValue(Program)
        this.setDefaultValueClaim(Claim)
        this.setState({
          loading: false,
          Product_List: NewProduct,
          lovActivity: Activity,
          lovCostCenter: CostCenter,
          Document_List: Document
        })
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false })
        console.log(e.message)
      }.bind(this)
    })
  }

  setDefaultValueClaim = (claim) => {
    this.setState({
      Program_Customer_ID: claim.program_customer_id,
      Claim_CostCenter: claim.ccid,
      Claim_Activity: claim.activity_id || '',
      Claim_DPP: claim.dpp ? this.thousandSeparator(claim.dpp) : '0',
      Claim_PPh: claim.pph ? this.thousandSeparator(claim.pph) : '0',
      Claim_PPhRate: claim.pph_rate ? claim.pph_rate.toString() : '0',
      Claim_PPn: claim.ppn ? this.thousandSeparator(claim.ppn) : '0',
      Claim_TaxDate: claim.tax_date ? new Date(claim.tax_date) : '',
      Claim_TaxNo: claim.tax_no || '',
      Claim_SKB: claim.skb || 'N',
      Claim_SKBNumber: claim.skb_number || '',
      Claim_CustomerReceipt: claim.cust_receipt_no || '',
      Claim_TotalAmount: claim.total ? this.thousandSeparator(claim.total) : '0',
      Claim_PPh_Type: claim.pph_type,
      Claim_Nett: this.thousandSeparator(claim.nett_claim || '0'),
      Claim_SKB_End_Date: claim.start_date_skb ? new Date(claim.start_date_skb) : '',
      Claim_SKB_Start_Date: claim.end_date_skb ? new Date(claim.end_date_skb) : '',
      Attachment_Jml_Display: claim.jml_display,
      Attachment_Jml_Data: claim.jml_additional_data,
      fileSKB: { filename: claim.doc_skb_filename || '', path: claim.doc_skb_path || '' },
      fileRequired: { filename: claim.doc_mandatory_filename || '', path: claim.doc_mandatory_path || '' },
      Claim_Reject_Reason: claim.suspend > 0 ? 'SUSPENDED BY RECEIPT' : ''
    })
  }

  setDefaultValue = (data) => {
    this.setState({
      General_PrincipalCode: data.org_initial,
      General_SkpNumber: data.skp_number,
      General_ProgramNumber: data.program_number,
      General_Principal: data.org_name,
      General_ReffNumber: data.ref_number,
      General_ProgramType: data.program_name,
      General_ProgramDescription: data.description,
      General_BudgetType: data.budget_type,
      General_AssignmentType: data.customer_assignment_type,
      General_ProgramSubmittedDate: data.creation_date ? moment(data.creation_date).format('DD-MMM-YYYY') : '',
      General_StartDate: data.start_date ? moment(data.start_date).format('DD-MMM-YYYY') : '',
      General_EndDate: data.end_date ? moment(data.end_date).format('DD-MMM-YYYY') : '',
      General_ClaimExpDate: data.claim_exp_date ? moment(data.claim_exp_date).format('DD-MMM-YYYY') : '',
      General_Budget: data.budget ? this.thousandSeparator(data.budget) : '0',
      General_BudgetRemaining: data.sisa_budget || 0,
      General_SalesTarget: data.sales_target ? this.thousandSeparator(data.sales_target) : '0',
      General_CustomerPPHType: data.pph_type,
      General_PPhRate: data.pph_rate,
      Customer_Id: data.customer_id,
      Customer_Name: data.customer_name || '',
      Customer_NPWP: data.npwp || '',
      Customer_NPWPAddress: data.npwp_address || '',
      Customer_NPWPName: data.npwp_name || '',
      Customer_BankName: data.bank_name || '',
      Customer_BankAccountNo: data.bank_account_no || '',
      Customer_BankAccountOwner: data.bank_account_owner || '',
      Customer_PKP_Badan: data.pkp_badan || '',
      Customer_Potong_Pajak: data.potong_pajak,
      Customer_Is_Hold: data.hold_by_kwitansi,
      Customer_Package: data.package || '',
      Claim_PPhRate: data.pph_rate,
      Attachment_Display: data.display,
      Attachment_Data: data.additional_data,
    })
  }

  renderGeneralInfo = () => {
    return (
      <div className="row">
        <div className="col-md-12">
          {this.showNotification()}
          <div className="card">
            <div className="card-header bg-light">
              <a className="text-decoration-none text-dark font-size-title" data-toggle="collapse" href="#multiCollapseExample2" role="button" aria-expanded="true" aria-controls="multiCollapseExample2">General Info <i className="fas fa-chevron-down font-size-small text-muted" /></a>
            </div>
            <div className="multi-collapse show" id="multiCollapseExample2">
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">SKP Number</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.General_SkpNumber} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Program Number</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.General_ProgramNumber} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Principal</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.General_Principal} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Reff Number / SKP</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.General_ReffNumber} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Program Type</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.General_ProgramType} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Program Description</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.General_ProgramDescription} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Budget Type</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.General_BudgetType} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Customer Assignment Type</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.General_AssignmentType} />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Start Date</label>
                      <input type="text" className="form-control col-md-3" disabled={true} value={this.state.General_StartDate} />
                      <label className="col-md-2 mt-1">End Date</label>
                      <input type="text" className="form-control col-md-3" disabled={true} value={this.state.General_EndDate} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Claim Exp Date</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.General_ClaimExpDate} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Budget</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.General_Budget} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Budget Remaining</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.General_BudgetRemaining} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Sales Target</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.General_SalesTarget} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Customer PPH Type</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.General_CustomerPPHType} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">PPh Rate (%)</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.General_PPhRate} />
                    </div>
                    <div className="form-group row">
                      <label className="col-md-4 mt-1">Program Submitted Date</label>
                      <input type="text" className="form-control col-md-8" disabled={true} value={this.state.General_ProgramSubmittedDate} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderCustomerInfo = () => {
    return (
      <div className="card">
        <div className="card-header bg-light">
          <a className="text-decoration-none text-dark font-size-title" data-toggle="collapse" href="#multiCollapseExample1" role="button" aria-expanded="false" aria-controls="multiCollapseExample1">Customer Info <i className="fas fa-chevron-down font-size-small text-muted" /></a>
        </div>
        <div className="multi-collapse show" id="multiCollapseExample1">
          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-md-4 mt-1">Customer</label>
                  <input type="text" className="form-control col-md-8" disabled={true} value={this.state.Customer_Name} />
                </div>
                <div className="form-group row">
                  <label className="col-md-4 mt-1">NPWP Name</label>
                  <input type="text" className="form-control col-md-8" disabled={true} value={this.state.Customer_NPWPName} />
                </div>
                <div className="form-group row">
                  <label className="col-md-4 mt-1">NPWP Address</label>
                  <input type="text" className="form-control col-md-8" disabled={true} value={this.state.Customer_NPWPAddress} />
                </div>
                <div className="form-group row">
                  <label className="col-md-4 mt-1">NPWP / NIK</label>
                  <input type="text" className="form-control col-md-8" disabled={true} value={this.state.Customer_NPWP} />
                </div>
                <div hidden className="form-group row">
                  <label className="col-md-4 mt-1">Potong Pajak</label>
                  <div className="col-md-8">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" id="customRadioInline1" name="customRadioInline1" class="custom-control-input" disabled={true} value="Y" checked={this.state.Customer_Potong_Pajak === 'Y' ? true : false} />
                      <label class="custom-control-label" for="customRadioInline1">Ya</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" id="customRadioInline2" name="customRadioInline2" class="custom-control-input" disabled={true} value="N" checked={(this.state.Customer_Potong_Pajak === 'N' || this.state.Customer_Potong_Pajak === null) ? true : false} />
                      <label class="custom-control-label" for="customRadioInline2">Tidak</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label className="col-md-4 mt-1">PKP Badan</label>
                  <div className="col-md-8">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" id="customRadioInline3" name="customRadioInline3" class="custom-control-input" disabled={true} value="Y" checked={(this.state.Customer_PKP_Badan === 'Y') ? true : false} />
                      <label class="custom-control-label" for="customRadioInline1">Ya</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input type="radio" id="customRadioInline4" name="customRadioInline4" class="custom-control-input" disabled={true} value="N" checked={(this.state.Customer_PKP_Badan === 'N' || this.state.Customer_PKP_Badan === null) ? true : false} />
                      <label class="custom-control-label" for="customRadioInline2">Tidak</label>
                    </div>
                  </div>
                </div>
                <div className="form-group row">
                  <label className="col-md-4 mt-1">Bank Name</label>
                  <input type="text" className="form-control col-md-8" disabled={true} value={this.state.Customer_BankName} />
                </div>
                <div className="form-group row">
                  <label className="col-md-4 mt-1">Bank Account No</label>
                  <input type="text" className="form-control col-md-8" disabled={true} value={this.state.Customer_BankAccountNo} />
                </div>
                <div className="form-group row">
                  <label className="col-md-4 mt-1">Bank Account Owner</label>
                  <input type="text" className="form-control col-md-8" disabled={true} value={this.state.Customer_BankAccountOwner} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  handleChangeInput = (event) => {
    let value = event.target.value;
    let name = event.target.name;

    if (name === "Claim_PPh" || name === "Claim_PPn" || name === "Claim_DPP") {
      value = this.thousandSeparator(value);
    } else if (name === "Claim_PPhRate") {
      value = value.replace(/[^0-9.]/g, "").replace(/\./g, "");
      if (parseInt(value) > 100) value = 100;
      if (parseInt(value) < 0) value = 0;
    }

    this.setState({ [name]: value });
    if (name === "Claim_PPh" || name === "Claim_PPn" || name === "Claim_DPP" || name === "Claim_PPhRate") {
      let app = this;
      if (name === "Claim_DPP") {
        let ppn = this.thousandSeparator(parseInt(this.removeSeparator(value)) / 10);
        app.setState({ Claim_PPn: ppn });
        window.setTimeout(() => {
          app.countPPH();
        }, 100);
      } else if (name === "Claim_PPhRate") {
        window.setTimeout(() => {
          app.countPPH();
        }, 100);
      }
      window.setTimeout(() => {
        app.calculateAmount();
        app.forceUpdate();
      }, 100);
    }
  };

  renderSKBAttachment = () => {
    if (this.state.Claim_SKB === 'Y') {
      if (this.state.fileSKB.filename && this.state.fileSKB.filename.length > 0) {
        return (
          <Link to={{ pathname: this.state.fileSKB.path }} target="_blank">
            <i className="fa fa-file text-danger" />&nbsp; {this.state.fileSKB.filename}
          </Link>
        )
      } else {
        return (
          <input type="file" data-type="SKB" onChange={this.handleUploadSingle.bind(this)} />
        )
      }
    }
  }

  handleClickSKB = (e) => {
    let value = e.target.value;
    let isChecked = e.target.checked;
    let app = this;
    if (isChecked) {
      this.setState({ Claim_SKB: value, Claim_PPh: 0 });
    } else {
      this.setState({ Claim_SKB: "N" });
      this.countPPH();
    }
    window.setTimeout(() => {
      app.calculateAmount();
    }, 100);
  }

  renderSKBNumber = () => {
    if (this.state.Claim_SKB === "Y") {
      return (
        <div className="form-group row">
          <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">SKB Number</label>
          <input
            type="text"
            autoComplete="off"
            className="form-control col-md-8"
            id="inputEmail3"
            name="Claim_SKBNumber"
            placeholder=""
            disabled={true}
            onChange={this.handleChangeInput.bind(this)}
            value={this.state.Claim_SKBNumber}
          />
        </div>
      );
    }
  };

  handleUploadSingle = (e) => {
    if (e.target.files.length === 0) {
      return false;
    }

    let files = e.target.files[0];
    let doctype = e.target.dataset.type;
    // validation
    let filename = files.name;
    var fileExt = filename.split(".").pop();
    var allowedFile = ["jpg", "png", "jpeg", "gif", "doc", "docx", "xls", "xlsx", "csv", "pdf"];
    if (allowedFile.indexOf(fileExt) < 0) {
      this.setState({ error: ["File extension not allowed"] });
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      return false;
    }

    const data = new FormData();
    data.append("myFile", files, files.name);
    this.setState({ loading: true });
    request.postnobodyCHD("/api/traces_chd/v1/util/upload-file", data, {
      success: function (response) {
        let data = response.data;

        if (doctype === "SKB") {
          let { fileSKB } = this.state;
          fileSKB.filename = data.filename;
          fileSKB.path = data.fullurl;
          this.setState(fileSKB);
        } else if (doctype === 'REQUIRED') {
          let { fileRequired } = this.state;
          fileRequired.filename = data.filename;
          fileRequired.path = data.fullurl;
          this.setState(fileRequired);
        }
        this.setState({ loading: false });
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
        console.log(e.message)
      }.bind(this),
    });
  };

  countPPH = () => {
    let { Claim_DPP, Claim_PPhRate } = this.state;
    let pph = this.thousandSeparator((parseInt(Claim_PPhRate || 0) / 100) * parseInt(this.removeSeparator(Claim_DPP)));
    this.setState({ Claim_PPh: pph });
  };

  calculateAmount = () => {
    let { Claim_DPP, Claim_PPn, Claim_PPh, Claim_TotalAmount } = this.state;
    let totalAmount = (parseFloat(this.removeSeparator(Claim_DPP)) || 0) + (parseFloat(this.removeSeparator(Claim_PPn)) || 0) - (parseFloat(this.removeSeparator(Claim_PPh)) || 0);
    totalAmount = Math.round(totalAmount); // ilham, menambahkan round
    this.setState({
      Claim_TotalAmount: this.thousandSeparator(totalAmount),
      Claim_PPn: this.thousandSeparator(Claim_PPn),
    });
  };

  handleTaxDate = (date) => {
    console.log(date)
    this.setState({ Claim_TaxDate: date })
  }

  renderClaimInfo = () => {
    return (
      <div className="card">
        <div className="card-header font-size-title bg-light">Claim Info</div>

        <div className="card-body">
          <h5>Attachment</h5>
          <div className="row">
            <div className="col-md-6">
              {this.renderDocumentV2()}
              <div className="row mt-2">
                <div className="col-md-12">
                  {this.renderUploadSingle("REQUIRED")}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                {this.renderJumlahDisplay()}
                {this.renderAdditionalData()}
              </div>
            </div>
          </div>
          <hr />
          <div className='row'>
            <div className='col-md-6'>
              <div className="form-group row">
                <label className="col-md-4 mt-1">Package</label>
                <input
                  type="text"
                  autoComplete="off"
                  disabled={true}
                  className="form-control col-md-8"
                  name="package"
                  value={this.state.Customer_Package}
                  onChange={this.handleChangeInput.bind(this)}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-md-4 mt-1 col-form-label">
                  Payment Method
                </label>
                <div className="col-sm-8 mt-2">
                  <div className="form-check form-check-inline">
                    <input
                      type="radio"
                      className="form-check-input"
                      name="Claim_PaymentMethod"
                      value="TRF"
                      checked={true}
                    />{" "}
                    Transfer
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-md-4 mt-1">Activity</label>
                {this.renderLovActivity()}
              </div>
              <div className="form-group row">
                <label className="col-md-4 mt-1">Reward Value</label>
                <input
                  type="text"
                  autoComplete="off"
                  disabled={true}
                  className="form-control col-md-8"
                  name="Claim_DPP"
                  value={this.state.Claim_DPP}
                  onChange={this.handleChangeInput.bind(this)}
                />
              </div>
              <div className="form-group row">
                <label className="col-md-4 mt-1">Tax No</label>
                <input
                  type="text"
                  placeholder="16 digits"
                  autoComplete="off"
                  className="form-control col-md-8"
                  name="Claim_TaxNo"
                  disabled={true}
                  value={this.state.Claim_TaxNo}
                  onChange={this.handleChangeInput.bind(this)}
                />
              </div>
              <div className="form-group row">
                <label className="col-md-4 mt-1">PPh Type</label>
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control col-md-8"
                  disabled={true}
                  name="Claim_PPh_Type"
                  onChange={this.handleChangeInput.bind(this)}
                  value={this.state.Claim_PPh_Type}
                />
              </div>
              <div className="form-group row">
                <label className="col-md-4 mt-1">PPh</label>
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control col-md-8"
                  disabled={true}
                  name="Claim_PPh"
                  onChange={this.handleChangeInput.bind(this)}
                  value={this.state.Claim_PPh}
                />
              </div>
              <div className="form-group row">
                <label className="col-md-4 mt-1">Nett Claim</label>
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control col-md-8"
                  disabled={true}
                  name="Claim_Nett"
                  value={this.state.Claim_Nett}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-md-4 mt-1">Cost Center</label>
                {this.renderLovCostCenter()}
              </div>
              <div className="form-group row">
                <label className="col-md-4 mt-1">PPN Rate (%)</label>
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control col-md-8"
                  disabled={true}
                  name="Claim_PPn"
                  onChange={this.handleChangeInput.bind(this)}
                  value={this.state.ppnrate}
                />
              </div>
              <div className="form-group row">
                <label className="col-md-4 mt-1">PPN</label>
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control col-md-8"
                  disabled={true}
                  name="Claim_PPn"
                  onChange={this.handleChangeInput.bind(this)}
                  value={this.state.Claim_PPn}
                />
              </div>
              <div className="form-group row">
                <label className="col-md-4 mt-1">Tax Date</label>
                <DatePicker
                  selected={this.state.Claim_TaxDate}
                  dateFormat="d-MMM-yyyy"
                  className="form-control col-md-8"
                  popperPlacement="top-end"
                  onChange={this.handleTaxDate}
                  disabled={true}
                />
              </div>
              <div className="form-group row">
                <label className="col-md-4 mt-1">PPh Rate (%)</label>
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control col-md-8"
                  disabled={true}
                  name="Claim_PPhRate"
                  onChange={this.handleChangeInput.bind(this)}
                  value={this.state.Claim_PPhRate}
                />
              </div>
              <div className="form-group row">
                <label className="col-md-4 mt-1">Total Claim (DPP)</label>
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control col-md-8"
                  disabled={true}
                  name="Claim_TotalAmount"
                  value={this.state.Claim_TotalAmount}
                />
              </div>
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col-md-6">
              <div className="form-group row">
                <label className="col-md-4 mt-1">SKB</label>
                <div className="col-sm-1 mt-2">
                  <div className="form-check form-check-inline">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      value="Y"
                      checked={this.state.Claim_SKB === "Y" ? true : false}
                      disabled={true}
                      onChange={this.handleClickSKB.bind(this)}
                    />
                  </div>
                </div>
                {this.renderSKBAttachment()}
              </div>
              {this.renderSKBPeriod()}
            </div>
            <div className="col-md-6">{this.renderSKBNumber()}</div>
          </div>
        </div>
      </div>
    );
  }

  renderLovActivity = () => {
    return (
      <select className="form-control col-md-8" disabled={true} name="Claim_Activity" value={this.state.Claim_Activity} onChange={this.handleChangeInput.bind(this)}>
        <option value="">- Select Activty Program -</option>
        {
          this.state.lovActivity.map((item, index) => (
            <option key={index} value={item.activity_id}>{item.activity_name}</option>
          ))
        }
      </select>
    )
  }

  renderLovCostCenter = () => {
    return (
      <select className="form-control col-md-8" disabled={true} name="Claim_CostCenter" value={this.state.Claim_CostCenter} onChange={this.handleChangeInput.bind(this)}>
        <option value="">- Select Cost Center -</option>
        {
          this.state.lovCostCenter.map((item, index) => (
            <option key={index} value={item.cc_id}>{item.cost_center}</option>
          ))
        }
      </select>
    )
  }

  renderProduct = () => {
    return (
      <div className="card">
        <div className="card-header font-size-title bg-light">
          Products
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-md-6 font-weight-bold">Product Description</div>
            <div className="col-md-3 font-weight-bold">Budget</div>
          </div>
          {this.renderProductDetail()}
        </div>
      </div>
    )
  }

  renderProductDetail = () => {
    return this.state.Product_List.map((item, index) => (
      <div className="row mt-2">
        <div className="col-md-6"><input type="text" className="form-control" value={item.item_description} disabled /></div>
        <div className="col-md-3"><input type="text" className="form-control" value={this.thousandSeparator(item.item_budget)} disabled /></div>
      </div>
    ))
  }

  handleChangeActual = (index, e) => {
    let value = e.target.value
    let { Product_List } = this.state

    Product_List[index].item_actual = this.thousandSeparator(value)
    this.setState(Product_List)
  }

  thousandSeparator = (value) => {
    if (value.length === 0) return

    value = value.toString().replace(/,/g, "").replace(/[^0-9.]/g, "");
    var parts = value.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  };

  removeSeparator = (value) => {
    if (!value || value.length === 0) {
      return
    }
    value = value.toString().replace(/,/g, "").replace(/[^0-9.]/g, "");
    return value;
  };

  handleClickDocument = (e) => {
    let is_checked = e.target.checked;
    let docId = e.target.value;
    let { Document_Selected } = this.state;
    if (is_checked) {
      Document_Selected.push({ documentId: docId });
    } else {
      let getIndex = _.findIndex(Document_Selected, function (o) {
        return parseInt(o.program_doc_id) === parseInt(docId);
      });
      Document_Selected.splice(getIndex, 1);
    }
    this.setState(Document_Selected);
  }

  renderDocumentV2 = () => {
    let { fileRequired } = this.state
    if (fileRequired.path.length === 0) {
      return this.state.Document_List.map((item, index) => (
        <div className="row">
          <div className="col-md-6" key={index}>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                value={item.program_doc_id}
                onClick={this.handleClickDocument.bind(this)}
                id="defaultCheck1"
              />
              <label className="form-check-label" htmlFor="defaultCheck1">
                {item.document_name}
              </label>
            </div>
          </div>
        </div>
      ))
    } else {
      return this.state.Document_List.map((item, index) => (
        <div className="row">
          <div className="col-md-6" key={index}>
            <div className="">
              <label className="form-check-label" htmlFor="defaultCheck1">
                <i className="fa fa-check text-success" />&nbsp;{item.document_name}
              </label>
            </div>
          </div>
        </div>
      ))
    }
  }

  handleRemoveFile = () => {
    let { fileRequired } = this.state
    fileRequired.filename = ''
    fileRequired.path = ''
    this.setState(fileRequired)
    this.setState({ Document_List: [] })
  }

  renderDocumentDisplay = () => {
    let { fileDisplay } = this.state
    if (fileDisplay.path.length === 0) {
      return (
        <div className="row">
          <div className="col-md-6">
            <div className="form-check">
              <input className="form-check-input" type="checkbox" value={1} name="Display_Attachment" onClick={this.handleClickDisplay.bind(this)} id="defaultCheck1" />
              <label className="form-check-label" htmlFor="defaultCheck1">Foto Display</label>
            </div>
          </div>
        </div>
      )
    } else {
      return (
        <div className="row">
          <div className="col-md-6">
            <div className="">
              <label className="form-check-label" htmlFor="defaultCheck1">Foto Display</label>
            </div>
          </div>
        </div>
      )
    }
  }

  handleClickDisplay = (e) => {
    let is_checked = e.target.checked;
    let { fileDisplay } = this.state
    if (is_checked) {
      this.setState({ Show_Display_Upload: true })
    } else {
      fileDisplay.filename = ''
      fileDisplay.path = ''
      this.setState({ Show_Display_Upload: false })
      this.setState(fileDisplay)
    }
  }

  renderUploadSingle = (type) => {
    if (type === 'REQUIRED') {
      if (this.state.fileRequired.path && this.state.fileRequired.path.length > 0) {
        return (
          <div className="row">
            <div className="col-md-12">
              <div className="form-group row">
                <label className="col-md-4">Upload Files</label>
                <div className="col-md-8"><i className="fa fa-file text-danger" />&nbsp; <a href={this.state.fileRequired.path} target="_blank">{this.state.fileRequired.filename}</a></div>
              </div>
            </div>
          </div>
        )
      } else {
        if (this.state.Document_Selected.length === this.state.Document_List.length) {
          return (
            <div className="row">
              <div className="col-md-12">
                <div className="form-group row">
                  <label className="col-md-4">Upload Files</label>
                  <input type="file" className="form-control col-md-8" data-type="REQUIRED" onChange={this.handleUploadSingle.bind(this)} />
                </div>
              </div>
            </div>
          )
        }
      }
    }
  }

  renderJumlahDisplay = () => {
    if (this.state.Attachment_Display === 'Y') {
      return (
        <div className="col-md-6">
          <div className="form-group row">
            <label className="col-md-6 mt-1">Jumlah Display</label>
            <input type="text" className="form-control col-md-6" disabled={true} autoComplete="off" name="Attachment_Jml_Display" value={this.state.Attachment_Jml_Display} onChange={this.handleChangeInput.bind(this)} />
          </div>
        </div>
      )
    }
  }

  renderAdditionalData = () => {
    if (this.state.Attachment_Data === 'Y') {
      return (
        <div className="col-md-6">
          <div className="form-group row">
            <label className="col-md-6 mt-1">Jumlah Data</label>
            <input type="text" className="form-control col-md-6" disabled={true} autoComplete="off" name="Attachment_Jml_Data" value={this.state.Attachment_Jml_Data} onChange={this.handleChangeInput.bind(this)} />
          </div>
        </div>
      )
    }
  }

  renderButton = () => {
    return (
      <div className="row">
        <div className="col-md-3">
          <button type="button" className="btn btn-primary btn-block" onClick={this.handleSubmit.bind(this)}><i className="fa fa-save" /> Approve</button>
        </div>
        <div className="col-md-3">
          <button type="button" className="btn btn-danger btn-block" onClick={this.handleReject.bind(this)}><i className="fa fa-times" /> Reject</button>
        </div>
        <div className="col-md-3">
          <button type="button" className="btn btn-warning btn-block" onClick={() => { this.props.history.push('/admin/claim-chd/approval') }}><i className="fa fa-arrow-left" /> Back</button>
        </div>
      </div>
    )
  }

  formValidation = () => {
    let { error } = this.state
    error = []

    // if (this.state.Claim_Activity === "") {
    //   error.push('Claim activity is required')
    // }
    if (this.state.Claim_CostCenter === "") {
      error.push('Claim cost center is required')
    }
    if (this.state.Claim_CustomerReceipt === "") {
      error.push('Claim customer receipt is required')
    }
    if (this.state.Claim_DPP === "" || this.state.Claim_DPP === '0') {
      error.push('Claim DPP is required')
    }
    if (this.state.Claim_TaxDate === "") {
      error.push('Claim tax date is required')
    }
    if (this.state.Claim_TaxNo === "" || this.state.Claim_TaxNo.length === 0) {
      error.push('Claim tax no is required')
    } else {
      let count = this.state.Claim_TaxNo.replace(/\.|-/g, "");
      if (count.length < 16 || count.length > 16) {
        error.push("Invalid Tax No, must be contain 16 digits (exclude . & -)");
      }
    }
    if (this.state.Claim_SKB === "Y") {
      if (!this.state.fileSKB.filename) {
        error.push("Please attach document for exemption certificate");
      }
      if (this.state.Claim_SKBNumber === "") {
        error.push("SKB Number is empty");
      }
    }

    if (this.state.Attachment_Display === 'Y') {
      if (this.state.Attachment_Jml_Display === '' || this.state.Attachment_Jml_Display === '0') {
        error.push('Jumlah display is required')
      }
    }

    if (this.state.Document_Selected.length < this.state.Document_List.length) {
      error.push('Please complete the required attachments')
    } else {
      if (this.state.fileRequired.path.length === 0) {
        error.push('Upload the required attachment')
      }
    }

    if (error.length > 0) {
      window.scrollTo(0, 0);
      this.setState({ error: error });
      return false;
    } else {
      return true;
    }
  }

  doApprove = (status) => {
    let url = '/api/traces_chd/v1/claim/approve'
    let { id } = this.props.match.params;
    let param = {
      claim_id: id,
      program_customer_id: this.state.Program_Customer_ID,
      status: status,
      reject_reason: this.state.Claim_Reject_Reason,
      requester: this.state.user.user_id,
      email: this.state.user.username
    }

    this.setState({ loading: true })
    request.postCHD(url, param, {
      success: function (response) {
        let msg = response.data.message || 'Claim berhasil diapprove'
        this.setState({
          loading: false,
          success: msg
        })
        window.scrollTo(0, 0)

        if (status === 'A') {
          // this.downloadKwitansi(id)
        }
        let app = this
        window.setTimeout(() => {
          app.props.history.push('/admin/claim-chd/approval')
        }, 3000)
      }.bind(this),
      error: function (e) {
        window.scrollTo(0, 0)
        this.setState({ loading: false, error: ['Failed to submit, please try again'] })
      }.bind(this)
    })
  }
  handleSubmit = () => {
    this.doApprove('A')
  }

  downloadKwitansi = (claim_id) => {
    let url = '/api/traces_chd/v1/assignment/doc-kwitansi?id=' + claim_id
    request.getCHD(url, {
      success: function(response) {
        let { fullpath } = response.data.data
        if (fullpath) {
          window.open(fullpath, '_blank')
        }
      }.bind(this),
      error: function(e) {
        console.log(e.message)
      }.bind(this)
    })
  }

  handleReject = () => {
    if (this.state.Claim_Reject_Reason === '') {
      alert('Reject Reason is required!')
      return false
    }
    this.doApprove('R')
  }

  renderReason = () => {
    return (
      <div className="row mb-3">
        <div className="col-md-6">
          <textarea placeholder="Reject Reason" className="form-control" value={this.state.Claim_Reject_Reason} onChange={this.handleChangeInput.bind(this)} name="Claim_Reject_Reason" rows={5}></textarea>
        </div>
      </div>
    )
  }

  renderSKBPeriod = () => {
    if (this.state.Claim_SKB === 'Y') {
      return (
        <div className="form-group row">
          <label className="col-md-4 mt-1">Start Date</label>
          <div className="col-md-3 p-0">
            <DatePicker
              selected={this.state.Claim_SKB_Start_Date}
              dateFormat="d-MMM-yyyy"
              className="form-control"
              popperPlacement="top-end"
              onChange={this.handleSKBDateStart}
              disabled={true}
            />
          </div>
          <label className="col-md-2 mt-1">End Date</label>
          <div className="col-md-3 p-0">
            <DatePicker
              selected={this.state.Claim_SKB_End_Date}
              dateFormat="d-MMM-yyyy"
              className="form-control"
              popperPlacement="top-end"
              onChange={this.handleSKBDateEnd}
              disabled={true}
            />
          </div>
        </div >
      )
    }
  }

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12 col-sx-12">
                <form className="form-horizontal">
                  <div className="card card-info">
                    <div className="card-body">
                      {this.renderGeneralInfo()}
                      {this.renderCustomerInfo()}
                      {this.renderProduct()}
                      {this.renderClaimInfo()}
                      {this.renderReason()}
                      {this.renderButton()}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    )
  }
}

export default ClaimDetailCHD